import { decimalLikeToDecimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { PriceSegmentType } from './enums';

export const resultsMetadataSchema = z.discriminatedUnion('segment', [
  z.object({
    segment: z.literal(PriceSegmentType.CustomerPotential),
    customerPotential: z.string().nullish(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.CustomerPortals),
    hasCustomerPortals: z.boolean(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.ProductOperationsCount),
    operationsCount: z.number().nullish(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.ProductComplexity),
    productComplexity: z.string().nullish(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.MarketIndustry),
    marketIndustry: z.string().nullish(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.LastTransactionAge),
    lastTransactionAgeInDays: z.number().nullish(),
  }),
  z.object({
    segment: z.literal(PriceSegmentType.LastGrossMargin),
    lastGrossMargin: decimalLikeToDecimal.nullish(),
  }),
]);

export type ResultsMetadata = z.infer<typeof resultsMetadataSchema>;
